export const formatDate = (value: Date | null | undefined): string => {
  if (!value || !(value instanceof Date) || isNaN(value.getTime())) {
    return '';
  }

  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const parseDate = (
  value: string | Date | null | undefined,
): string | undefined => {
  if (!value) {
    return undefined;
  }

  const date = value instanceof Date ? value : new Date(value);

  return formatDate(date) || undefined;
};
